module.exports = __webpack_public_path__ + "static/img/NATE-CADDY.b369a1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NATE-CADDY.jpg
// module id = bh5C
// module chunks = 0